import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ClientDTO,
  Currency,
  ParkerExtractReportParameterDTO,
  ParkerExtractReportSummaryDTO,
} from '../../../../../base/models/models.swagger.generated';
import { StringHelper } from '../../../../../base/shared/string-helper';
import { GridConstantsFactory } from '../../../../../base/shared/syncfusion/grid-constants-factory';
import { ClientService } from '../../../../../base/services/client/client.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SaveOptions } from '../../../reports-footer/save-options';
import { reportsRoute } from '../../../../../core/routing/route-names';
import { ParkerExtractReportService } from '../parker-extract-report.service';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../../../../base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from '../../../../../base/spinner/spinner.service';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { AuthService } from '../../../../../base/services/auth.service';
import { DateTime } from 'luxon';
import { ParkerExtractFormType } from '../parker-extract-form/parker-extract-form.type';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe, DatePipe } from '@angular/common';
import { ParkerExtractFormComponent } from '../parker-extract-form/parker-extract-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-parker-extract-report',
    templateUrl: './parker-extract-report.component.html',
    styleUrls: ['./parker-extract-report.component.scss'],
    imports: [
        TitleBarComponent,
        ParkerExtractFormComponent,
        GridModule,
        ReportsFooterComponent,
        DecimalPipe,
        DatePipe,
        TranslateModule,
    ]
})
export class ParkerExtractReportComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('subscriptionSummary') public subscriptionSummaryGrid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public data: DataManager;
  public summaryData: ParkerExtractReportSummaryDTO;
  public summaryCurrency: string;

  public filterForm: FormGroup<ParkerExtractFormType> = this.fb.group({
    month: [DateTime.now().startOf('month').toJSDate()],
    parkerId: [null],
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();

  constructor(public clientService: ClientService,
              private fb: FormBuilder,
              private router: Router,
              private authService: AuthService,
              private spinnerService: SpinnerService,
              private parkerExtractReportService: ParkerExtractReportService) {
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.parkerExtractReportService, this.spinnerService),
    });

    //Initially get all
    if (this.selectedClient || this.authService.isUserStandardUser()) {
      this.searchReports();
    }
  }

  public get allowClientSelection(): boolean {
    return this.authService.isUserAdminOrClientAdmin() || this.authService.hasUserClientAssigned();
  }

  public searchReports(): void {

    if (this.filterForm.controls.month.value && this.filterForm.controls.parkerId.value) {
      const reportParameters = new ParkerExtractReportParameterDTO({
        parkerId: this.filterForm.controls.parkerId.value,
        month: DateTime.fromJSDate(this.filterForm.controls.month.value).startOf('month').toFormat('yyyy-MM-dd')
      });
      this.parkerExtractReportService.reportParameters = reportParameters;
      try {
        this.grid?.refresh();
      } catch (e) {
        // Ignore error when grid is in transition state
      }
      this.summaryData = null;
      this.parkerExtractReportService.getReportSummary(reportParameters)
        .subscribe(summary => {
          this.summaryData = summary;
          this.summaryCurrency = this.formatCurrency(summary.currency);
        });

    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.show();
    const reportParameters = new ParkerExtractReportParameterDTO({
      parkerId: this.filterForm.controls.parkerId.value,
      month: DateTime.fromJSDate(this.filterForm.controls.month.value).startOf('month').toFormat('yyyy-MM-dd')
    });
    this.parkerExtractReportService.exportReport(reportParameters, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.hide();
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  public formatTime(minutes: number): string {
    return StringHelper.transformToTimeRepresentation(minutes);
  }

  public formatCurrency(type: Currency): string {
    return 'i18n.shared.currencies.' + Currency[type];
  }
}
